import React, { useState, useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { collection, getDocs, query, documentId } from 'firebase/firestore';
import { db, getFromDB } from "../../firebase";
import { Cache } from "../utils/Cache"
import { Utils } from "../utils/Utils"


import './Preseason.css'
import 'react-tabs/style/react-tabs.css';

function Preseason() {

  const [teams, setTeams] = useState([])
  const [teamsSelect, setTeamsSelect] = useState([])
  const [teamSelected, setTeamSelected] = useState({})
  const [scheduleToday, setScheduleToday] = useState([])
  const [scheduleNext, setScheduleNext] = useState([])
  const [schedulePrevious, setSchedulePrevious] = useState([])
  const [scheduleByTeam, setScheduleByTeam] = useState([])

  useEffect(() => {
    const getTeamsPrimeraFEBFromFirestore = async () => {
      const teamsPrimeraFEB = Cache.getWithExpiry(Cache.keyTeams)
      if (teamsPrimeraFEB === null) {
        try {
          const queryData = {table: 'teams', conditions: {field: 'otherCategory', operator: '==', value: false}, order: 'order'}
          const dataResults = await getFromDB(queryData)
          setTeamsSelect(dataResults);
          Cache.setWithExpiry(Cache.keyTeams, dataResults)
          return dataResults
        } catch (error) {
          console.error('Error al obtener los datos de los equipos:', error);
        }
      }
      else {
        setTeamsSelect(teamsPrimeraFEB)
        return teamsPrimeraFEB
      }
    };

    const getScheduleFromFirestore = async (teams1FEB) => {
      try {
        const scheduleCollectionRef = collection(db, 'schedule');
        const scheduleQuery = query(scheduleCollectionRef);
        const snapshot = await getDocs(scheduleQuery);
        const scheduleData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        if (scheduleData.length > 0) {
          const scheduleOrdered = scheduleData[0].schedule.sort((a,b)=>Utils.compareDates(a.dateMatch,b.dateMatch))
          const scheduleOrderedInverse = [...scheduleOrdered].sort((a,b)=>Utils.compareDates(b.dateMatch,a.dateMatch))
          setScheduleToday(scheduleOrdered.filter(match => Utils.compareDateWithToday(match.dateMatch) === 0))
          setScheduleNext(scheduleOrdered.filter(match => Utils.compareDateWithToday(match.dateMatch) === 1))
          setSchedulePrevious(scheduleOrderedInverse.filter(match => Utils.compareDateWithToday(match.dateMatch) === -1))
          setScheduleByTeam(getScheduleByTeams(teams1FEB, scheduleOrdered))
          return scheduleData[0].schedule
        }
        
      } catch (error) {
        console.error('Error al obtener los datos de los partidos:', error);
      }
    };

    const getOtherTeamsFromFirestore = async (teams1FEB, matches) => {
      const otherTeams = []
      const otherTeamsIds = []
      matches.forEach(match => {
        const teamLocalStored = localStorage.getItem("team-"+match.local)
        const teamVisitorStored = localStorage.getItem("team-"+match.visitor)
        if (!existsTeamInArray(match.local, teams1FEB)  && !otherTeamsIds.includes(match.local) && teamLocalStored === null) {
          otherTeamsIds.push(match.local)
        } else if (teamLocalStored !== null && !existsTeamInArray(match.local, otherTeams)) {
          otherTeams.push(JSON.parse(teamLocalStored))
        }
        if (!existsTeamInArray(match.visitor, teams1FEB)  && !otherTeamsIds.includes(match.visitor) && teamVisitorStored === null) {
          otherTeamsIds.push(match.visitor)
        } else if (teamVisitorStored !== null && !existsTeamInArray(match.visitor, otherTeams)) {
          otherTeams.push(JSON.parse(teamVisitorStored))
        }
      })
      if (otherTeamsIds.length > 0) {
        const chunkedIds = Utils.splitArray(otherTeamsIds, 30)
        for (let chunk of chunkedIds) {
          const queryData = {table: 'teams', conditions: {field: documentId(), operator: 'in', value: chunk}}
          const dataResults = await getFromDB(queryData)
          if (dataResults.length > 0){    
            dataResults.forEach(dataTeam => {
              otherTeams.push(dataTeam)
              localStorage.setItem("team-"+dataTeam.id, JSON.stringify(dataTeam))
            })
          }
        }
      }
      setTeams(teams1FEB.concat(otherTeams))
      

    }
    getTeamsPrimeraFEBFromFirestore().then(teams1FEB => {
      getScheduleFromFirestore(teams1FEB).then(matches => {
        getOtherTeamsFromFirestore(teams1FEB,matches)
      });
    })

    const existsTeamInArray = (idTeam, teamsArray) => {   
      const index = teamsArray.findIndex(teamA => teamA.id === idTeam)
      return index !== -1 
    }

    const getScheduleByTeams = (teams1FEB, scheduleData) => {
      const arraySchedule = []
      teams1FEB.forEach(team => {
        arraySchedule[team.id] = scheduleData.filter(match => match.local === team.id || match.visitor === team.id)
      })
      return arraySchedule
    }
    
  },[]);

  const getMatches = (type, team) => {
    if (type === "today") {
      return scheduleToday
    } else if (type === "next") {
      return scheduleNext
    } else if (type === "previous") {
      return schedulePrevious
    } else if (type === "byTeam") {
      return scheduleByTeam[team]
    }
    return []
  }

  const getSchedule = (type, team) => {
    const matches = getMatches(type, team)
    if (matches !== undefined && matches.length > 0) {
      const distinctDates = getDistinctDates(matches)
      return distinctDates.map(dateMatches => showMatchesByDate(matches, dateMatches, type))  
    } else {
      return <>No hay partidos</>
    }     
  }

  const showMatchesByDate = (matches, dateMatches, type) => {
    if (type === "today") {
      return <table className="data-table matches">
      <tbody>
        {matches.map((match,i) => showRowMatch(match, i, type))}
      </tbody>
      </table>
    } else {
      const date2 = Utils.parseSpanishDate(dateMatches)
      const matchesDate = matches.filter(match => {
        const date1 = Utils.parseDate(match.dateMatch, true)
        return date1.getYear() === date2.getYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate()
      })
      return <div>
        <p className="date-matches">{Utils.formatSpanishDate(date2)}</p>
        <table className="data-table matches">
          <tbody>
            {matchesDate.map((match,i) => showRowMatch(match, i, type))}
          </tbody>
          </table>
      </div>
    }
  }

  const getDistinctDates = matches => {
    const uniqueDatesSet = new Set();

    matches.forEach(match => {
      const date = new Date(match.dateMatch);
      const formattedDate = date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      uniqueDatesSet.add(formattedDate);
  });

  return Array.from(uniqueDatesSet);
  }

  const showRowMatch = (match, i, type) => {
    const local = teams.filter(team => team.id === match.local)[0]
    const visitor = teams.filter(team => team.id === match.visitor)[0]
    const logoLocal = local !== undefined && local.url_logo !== undefined ? <img className="logo-team-small" src={local.url_logo} alt={local.url_logo}></img> : <></>
    const logoVisitor = visitor !== undefined && visitor.url_logo !== undefined ? <img className="logo-team-small" src={visitor.url_logo} alt={visitor.url_logo}></img> : <></>
    const nameLocal = local !== undefined && local.name !== undefined ? <span className={showClassWinner(match,true)}>{local.name}</span> : <></>
    const nameVisitor = visitor !== undefined && visitor.name !== undefined ? <span className={showClassWinner(match,false)}>{visitor.name}</span> : <></>
    return <>
      <tr className="first-tr" key={i}>
        <td className="logo-local">{logoLocal}</td>
        <td className="date-match">{type !== "previous" && (type !== "byTeam" || match.ptsLocal === 0) ? Utils.showTimeStr(match.dateMatch) : ''}</td>
        <td className="logo-visitor">{logoVisitor}</td>  
      </tr>
      <tr key={`${i}-2`}>
        <td>{nameLocal}</td>
        {type !== "next"?<td className="score-match">{showScore(match)}</td> : <td></td>}
        <td>{nameVisitor}</td>
      </tr>
      <tr className="last-tr" key={`${i}-3`} >
        <td></td>
        <td>{showVideo(match.urlVideo)}</td>
        <td className="observations">{match.observations !== "" ? <>* {match.observations}</>:<></>}</td>
      </tr>
    </>
  }

  const showClassWinner = (match,isLocal) => {
    const {ptsLocal, ptsVisitor} = match
    if (ptsLocal > 0 && ptsVisitor > 0) {
      if (isLocal && ptsLocal > ptsVisitor) {
        return "winner"
      }
      if (!isLocal && ptsLocal < ptsVisitor) {
        return "winner"
      }
    }

    return ""
  }

  const showScore = match => {
    if (match.ptsLocal > 0) {
      if (match.urlStats !== "") {
        return <a target="_blank" rel="noreferrer" href={match.urlStats}>{match.ptsLocal} - {match.ptsVisitor}</a>
      } else {
        return <>{match.ptsLocal} - {match.ptsVisitor}</>
      }
    }
    return <></>
  }

  const showVideo = urlVideo => {
    if (urlVideo !== '') {
      return <a href={urlVideo} target="_blank" rel="noreferrer"><img src="./assets/video.png" alt="Stream" className="video-icon"></img></a>
    }
    return <></>
  }

  const showSelectedTeams = () => {
    const teamsFiltered = teamsSelect.filter(team => team.otherCategory === undefined || !team.otherCategory)
    if (teamsFiltered.length > 0) {
      return teamsFiltered.map(team => <option key={team.id} value={team.id}>{team.name}</option>)
    }
    return <></>
  }

  const getByTeam = () => {
    return <>
      <select 
      onChange={(e) => setTeamSelected(e.target.value)}>
        <option value=""></option>
        {showSelectedTeams()}
      </select>
      <div>
        {getSchedule("byTeam",teamSelected)}
      </div>
      </>
  }
  
  return (
    <div className="preseason-container">
      <div className="header"><h2>Pretemporada</h2></div>
      <div className="container-preseason">
        <Tabs>
            <TabList>
              <Tab>Hoy</Tab>
              <Tab>Próximos partidos</Tab>
              <Tab>Partidos anteriores</Tab>
              <Tab>Por equipo</Tab>
            </TabList>

            <TabPanel>{getSchedule("today")} </TabPanel>
            <TabPanel>{getSchedule("next")}</TabPanel>
            <TabPanel>{getSchedule("previous")}</TabPanel>
            <TabPanel>{getByTeam()}</TabPanel>
        </Tabs>
      </div>
    </div>
  )
}

export default Preseason